import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";
import {ValidationStateUI_Login} from '../../shared/validationStateUI';



const initialStateLogin = {
    ...ValidationStateUI_Login
}

const loginValid = (state, action) => {
    return updateObject(state, {
        ...action.payload
    })
}
export const LoginValidationUIReducer = (state = initialStateLogin, action) => {
    switch (action.type) {
        case actionTypes.SET_VALIDATION_UI_LOGIN_FORM:
            return loginValid(state, action)
        default:
            return state;
    }

}